import React, { Component, Fragment } from 'react';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import Script from 'react-load-script';
import Helmet from 'react-helmet';

const DashboardPage = DisplayComponent(
  class DashboardPage extends Component {
    render() {
      // Use Razzle URLs by default
      let assetUrlPaths = {
        js: '/bundle/js/main.js',
        css: '/bundle/stylesheets/dashboard.css',
        cmsBaseCss: '/bundle/stylesheets/dashboard-cms-base.css'
      };
      if (process.env.RAZZLE_content_api_uri_base === '') {
        // Use Django URLs for local dev using the Django CMS editor
        assetUrlPaths = {
          js: '/static/formlabs-web/public/cms-dashboard/js/main.js',
          css:
            '/static/formlabs-web/public/cms-dashboard/stylesheets/dashboard.css',
          cmsBaseCss:
            '/static/formlabs-web/public/cms-dashboard/stylesheets/dashboard-cms-base.css'
        };
      }
      return (
        <Fragment>
          <Helmet>
            <title>Dashboard | Formlabs</title>
            <link rel="stylesheet" href={assetUrlPaths.css} />
            <link rel="stylesheet" href={assetUrlPaths.cmsBaseCss} />
            <body data-dashboard="true" />
          </Helmet>
          <div id="content">
            <div id="app-container" />
          </div>
          <Script url={assetUrlPaths.js} />
        </Fragment>
      );
    }
  }
);

export default DashboardPage;
